<template>
  <az-container>
    <az-form>
      <div class="li-tabela">
        <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                      :pagination.sync="paginacaoInterna" :loading="false"
                      no-data-text="Não há protocolos encontrados"
                      hide-actions class="az-table-list table-protocolos">
          <template slot="items" slot-scope="props">
            <td>
              <v-tooltip top class="no-mobile">
                <span slot="activator" class="d-inline-block text-truncate max-10">
                  {{ verificarProtocoloHash(props.item) }}
                </span>
                {{ verificarProtocoloHash(props.item) }}
              </v-tooltip>
            </td>
            <td>
              <span>{{ props.item.fornecedorRazaoSocial }}</span>
            </td>
            <td>
              <span>{{ props.item.processo }}</span>
            </td>
            <td>
              <span>{{ props.item.data | az-date('DD/MM/YYYY HH:mm:ss')}}</span>
            </td>
            <td>
              <span>{{ props.item.origem }}</span>
            </td>
            <td>
              <span>{{ props.item.situacao }}</span>
            </td>
            <td class="this-table-actions">
              <v-tooltip top>
                <a slot="activator" @click="visualizarProcesso(props.item)">
                  <v-icon size="20">login</v-icon>
                </a>
                  Visualizar
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
        <div class="az-pagination">
          <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
          <div class="az-select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
          </div>
        </div>
      </div>
    </az-form>
  </az-container>
</template>
<script>
import ExpandirTexto from '@/commons/components/ExpandirTexto'

export default {
  name: "ProtocoloBuscaTabela",
  components: {ExpandirTexto},
  props: ['itens', 'paginacao', 'paginas', 'totalItens'],
  data() {
    return {
      paginacaoInterna: this.paginacao,
      linhasPorPagina: [10, 25, 50, 100],
      colunas: [
        {
          text: 'Protocolo',
          value: 'protocoloProcesso',
          sortable: false,
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Fornecedor',
          value: 'fornecedorRazaoSocial',
          sortable: false,
          align: 'left',
          width: '200px',
          class: 'primary--text'
        },
        {
          text: 'Processo',
          value: 'processo',
          sortable: false,
          align: 'left',
          width: '200px',
          class: 'primary--text'
        },
        {
          text: 'Data',
          value: 'data',
          sortable: false,
          align: 'left',
          width: '150px',
          class: 'primary--text'
        },
        {
          text: 'Origem',
          value: 'origem',
          sortable: false,
          align: 'left',
          width: '150px',
          class: 'primary--text'
        },
        {
          text: 'Situação',
          value: 'situacao',
          sortable: false,
          align: 'left',
          width: '150px',
          class: 'primary--text'
        },
        {
          text: 'Ações',
          sortable: false,
          align: 'left',
          width: '100px',
          class: 'primary--text'
        }
      ]
    }
  },
  created() {
    this.setarDadosColunasDinamicas()
  },
  watch: {
    paginacaoInterna: {
      handler(novoValor) {
        this.$emit('paginar', novoValor)
      },
      deep: true
    }
  },
  methods:{
    setarDadosColunasDinamicas(){
      if (this.$route.params.tipo !== 'PROTOCOLO_DOCUMENTO') {
          this.colunas[0].text = 'Hash'
      }
    },
    verificarProtocoloHash(item){
      if(item.protocolo)
        return item.protocolo
      if(item.hash)
        return item.hash
      return '---'
    },
    visualizarProcesso(item){
      this.$emit('visualizar', item)
    }
  }
}
</script>
<style scoped lang="stylus">

.az-container .table-protocolos tbody tr td
  padding 0px 10px !important

@media (max-width: 720px)
  .table-protocolos
    td:nth-of-type(1):before
      content: "Protocolo:"

    td:nth-of-type(2):before
      content: "Fornecedor:"

    td:nth-of-type(3):before
      content: "Processo:"

    td:nth-of-type(4):before
      content: "Tipo:"

    td:nth-of-type(5):before
      content: "Data:"

    td:nth-of-type(6):before
      content: "Origem:"

    td:nth-of-type(7):before
      content: "Situação:"

    td:nth-of-type(8):before
      content: "Visualizar:"

  .this-table-actions
    text-align: left !important;

    i
      font-size 20px !important

    a
      margin 0 !important

  .az-table-list tbody tr td
    padding: 2px 10px !important

</style>
